(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const CART_URL = `${ROOT}cart.js`;

  async function getCart() {
    const response = await fetch(CART_URL, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Kunde inte läsa varukorgen.');
    return response.json();
  }

  function updateCartCount(count) {
    document.querySelectorAll('.sb-header__cart-count').forEach((badge) => {
      badge.textContent = count || 0;
      badge.hidden = !count;
    });
    const cartLink = document.getElementById('sb-draft-cart');
    if (cartLink) cartLink.setAttribute('aria-label', `Varukorg, ${count || 0} produkter`);
  }

  function showToast(message) {
    let toast = document.getElementById('sb-test-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'sb-test-toast';
      toast.className = 'sbt-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span></span><a href="/cart">Visa varukorg</a>';
      document.body.appendChild(toast);
    }
    toast.querySelector('span').textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(window.__sbToastTimer);
    window.__sbToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }

  async function refreshCart() {
    try {
      const cart = await getCart();
      updateCartCount(cart.item_count);
      return cart;
    } catch (_) {
      return null;
    }
  }

  function enhanceDrawer() {
    const summary = document.querySelector('#cart-drawer .cart-drawer__summary');
    if (!summary || summary.querySelector('.sb-drawer-confidence')) return;
    const note = document.createElement('div');
    note.className = 'sb-drawer-confidence';
    note.innerHTML = '<span>🇸🇪 Svenskt lager</span><span>↩️ 14 dagars öppet köp</span>';
    summary.appendChild(note);
  }

  async function refreshDrawer() {
    if (/\/cart\/?$/.test(location.pathname)) return null;
    try {
      const response = await fetch(`${ROOT}?sections=cart-drawer-section`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Kunde inte uppdatera varukorgen.');
      const sections = await response.json();
      const html = sections['cart-drawer-section'];
      if (!html) return document.querySelector('#cart-drawer');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('#shopify-section-cart-drawer-section');
      const current = document.querySelector('#shopify-section-cart-drawer-section');
      if (fresh && current) current.replaceWith(fresh);
      enhanceDrawer();
      return document.querySelector('#cart-drawer');
    } catch (_) {
      return document.querySelector('#cart-drawer');
    }
  }

  async function openCart(options = {}) {
    if (/\/cart\/?$/.test(location.pathname)) return false;
    const shouldRefresh = options.refresh !== false;
    let drawer = shouldRefresh ? await refreshDrawer() : document.querySelector('#cart-drawer');
    if (!drawer) return false;
    const open = () => {
      drawer = document.querySelector('#cart-drawer') || drawer;
      if (typeof drawer.open === 'function') drawer.open();
    };
    if (typeof drawer.open === 'function') open();
    else customElements.whenDefined('theme-drawer').then(open).catch(() => {});
    enhanceDrawer();
    return true;
  }

  document.addEventListener('click', (event) => {
    const cartLink = event.target.closest?.('#sb-draft-cart');
    if (!cartLink) return;
    if (!document.querySelector('#cart-drawer')) return;
    event.preventDefault();
    openCart({ refresh: true });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-sb-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const old = button.textContent;
    button.disabled = true;
    button.textContent = 'Lägger till…';
    try {
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Produkten kunde inte läggas till.');
      button.textContent = '✓ Tillagd';
      const cart = await refreshCart();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart || {} }));
      await openCart({ refresh: true });
      setTimeout(() => {
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = old;
        }
      }, 950);
    } catch (_) {
      button.disabled = false;
      button.textContent = 'Försök igen';
      showToast('Kunde inte lägga till produkten. Försök igen.');
      setTimeout(() => { if (button.isConnected) button.textContent = old; }, 1600);
    }
  });

  function boot() {
    refreshCart();
    enhanceDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', refreshCart);
  document.addEventListener('cart:refresh', () => setTimeout(refreshCart, 80));
  document.addEventListener('cart:updated', (event) => {
    const count = event.detail?.item_count;
    if (Number.isFinite(count)) updateCartCount(count);
    else setTimeout(refreshCart, 80);
  });

  window.SBTest = { getCart, refreshCart, updateCartCount, showToast, refreshDrawer, openCart };
})();